import { mutatorAction } from 'satcheljs';
import type ConversationItemParts from 'owa-mail-store/lib/store/schema/ConversationItemParts';

export const updateConversationCopilotNeedsReplyMutator: (
    conversation: ConversationItemParts,
    conversationCopilotNeedsReply: boolean | undefined
) => void = mutatorAction(
    'updateConversationCopilotNeedsReply',
    (
        conversation: ConversationItemParts,
        conversationCopilotNeedsReply: boolean | undefined
    ): void => {
        conversation.conversationCopilotNeedsReply = conversationCopilotNeedsReply;
    }
);
